export function formatDueDate(value: string | null): string {
  if (!value) return "";
  const today = new Date();
  const d = new Date(`${value}T00:00:00`);
  const a = new Date(today.getFullYear(), today.getMonth(), today.getDate()).getTime();
  const b = d.getTime();
  const days = Math.round((b - a) / 86400000);
  if (days === 0) return "今日";
  if (days === 1) return "明日";
  if (days === -1) return "昨日";
  return value.slice(5).replace("-", "/");
}

export function isOverdue(value: string | null, completed: boolean): boolean {
  if (!value || completed) return false;
  const today = new Date();
  const a = new Date(today.getFullYear(), today.getMonth(), today.getDate()).getTime();
  return new Date(`${value}T00:00:00`).getTime() < a;
}

export function ago(value: string | null): string {
  if (!value) return "未同期";
  const sec = Math.max(0, Math.round((Date.now() - new Date(value).getTime()) / 1000));
  if (sec < 60) return "たった今";
  if (sec < 3600) return `${Math.floor(sec / 60)}分前`;
  if (sec < 86400) return `${Math.floor(sec / 3600)}時間前`;
  return `${Math.floor(sec / 86400)}日前`;
}
